<section class="header">
  <section class="header-desktop mdc-layout-grid">
    <div class="header-desktop-left">
      <a routerLink="/" class="header-desktop-navigation-logo">
        <bau365-shell-logo-dark></bau365-shell-logo-dark>
      </a>
      @if (fairsConfiguration$ | async; as fairsConfiguration) { @if (detailed) {
      <ul class="header-desktop-navigation-list">
        <li class="header-desktop-navigation-list-item">
          <a
            [routerLink]="['/fairs', fairsConfiguration.bauInsights]"
            (click)="closeMenu()"
            class="header-link insights-link hover-help"
            routerLinkActive="header-link-active"
            data-text="Insights">
            Insights
          </a>
          <div class="submenu-wrapper">
            <ul class="submenu">
              <li class="submenu__item">
                <a
                  [routerLink]="['/fairs', fairsConfiguration.bauInsights, 'exhibitors']"
                  class="submenu__link"
                  routerLinkActive="submenu__linkActive"
                  data-text="Unternehmensverzeichnis"
                  i18n-data-text="@@uiShell-insightsCompanyDirectoryLinkLabel-pseudo"
                  i18n="@@uiShell-insightsCompanyDirectoryLinkLabel">
                  Unternehmensverzeichnis
                </a>
              </li>
              @if ( !fairsConfiguration.fairs[fairsConfiguration.bauInsights].discoveryHidden && (searchEnabled$ |
              async) ) {
              <li class="submenu__item">
                <a
                  [routerLink]="['/fairs', fairsConfiguration.bauInsights, 'search']"
                  class="submenu__link"
                  routerLinkActive="submenu__linkActive"
                  data-text="Entdecken"
                  i18n-data-text="@@uiShell-insightsSearchLinkLabel-pseudo"
                  i18n="@@uiShell-insightsSearchLinkLabel">
                  Entdecken
                </a>
              </li>
              }
            </ul>
          </div>
        </li>
        @if (fairsConfiguration.fairs[fairsConfiguration.activeFair]; as activeFair) {
        <li class="header-desktop-navigation-list-item">
          <a
            [routerLink]="['/fairs', fairsConfiguration.activeFair]"
            (click)="closeMenu()"
            class="header-link hover-help"
            routerLinkActive="header-link-active"
            i18n="@@uiShell-activeFairLinkLabel"
            i18n-data-text="@@uiShell-activeFairLinkLabel-pseudo"
            [attr.data-text]="activeFair.name">
            {{ activeFair.name }}
          </a>
          <div class="submenu-wrapper">
            <ul class="submenu">
              <li class="submenu__item">
                <a
                  [routerLink]="['/fairs', fairsConfiguration.activeFair, 'exhibitors']"
                  class="submenu__link"
                  routerLinkActive="submenu__linkActive"
                  data-text="Ausstellerverzeichnis"
                  i18n-data-text="@@uiShell-activeFairExhibitorDirectoryLinkLabel"
                  i18n="@@uiShell-activeFairExhibitorDirectoryLinkLabel"
                  >Ausstellerverzeichnis</a
                >
              </li>
              @if (activeFair.hallplan && (hallplanEnabled$ | async)) {
              <li class="submenu__item">
                <a
                  [routerLink]="['/fairs', fairsConfiguration.activeFair, 'hall-plan']"
                  class="submenu__link"
                  routerLinkActive="submenu__linkActive"
                  data-text="Hallenplan"
                  i18n-data-text="@@uiShell-activeFairHallplanLinkLabel-pseudo"
                  i18n="@@uiShell-activeFairHallplanLinkLabel">
                  Hallenplan
                </a>
              </li>
              } @if (!activeFair.discoveryHidden && (searchEnabled$ | async)) {
              <li class="submenu__item">
                <a
                  [routerLink]="['/fairs', fairsConfiguration.activeFair, 'search']"
                  class="submenu__link"
                  routerLinkActive="submenu__linkActive"
                  data-text="Entdecken"
                  i18n-data-text="@@uiShell-activeFairSearchLinkLabel-pseudo"
                  i18n="@@uiShell-activeFairSearchLinkLabel">
                  Entdecken
                </a>
              </li>
              } @if ((togglesFacade.flag('kill-program') | async) !== true) { @if (activeFair.program && programEnabled$
              | async) {
              <li class="submenu__item">
                <a
                  [routerLink]="['/fairs', fairsConfiguration.activeFair, 'program']"
                  class="submenu__link"
                  routerLinkActive="submenu__linkActive"
                  data-text="Rahmenprogramm"
                  i18n-data-text="@@uiShell-activeFairProgramLinkLabel-pseudo"
                  i18n="@@uiShell-activeFairProgramLinkLabel">
                  Rahmenprogramm
                </a>
              </li>
              } }
            </ul>
          </div>
        </li>
        }
        <li class="header-desktop-navigation-list-item">
          @if (['/fairs']; as route) {
          <a
            [routerLink]="route"
            (click)="closeMenu()"
            class="header-link hover-help"
            [class.header-link-active]="(isAllFairsRouteActive(route) | async) === true"
            i18n="@@uiShell-allFairsLinkLabel"
            i18n-data-text="@@uiShell-allFairs-pseudo"
            data-text="Alle Veranstaltungen">
            Alle Veranstaltungen
          </a>
          } @if ((isPastFairActive$ | async) === true) { @if (fairId$ | async; as fairId) { @if
          (fairsConfiguration.fairs[fairId]; as fair) {
          <div class="submenu-wrapper">
            <ul class="submenu submenu--past-fair">
              <li class="submenu__item submenu__item__show-all">
                <a [routerLink]="['/fairs']" class="submenu__link submenu__link--show-all">
                  <span class="show-all">
                    <mat-icon class="show-all__icon">arrow_left_alt</mat-icon>
                    <span class="show-all__text" i18n="@@uiShell-allFairs-jumpBackLinkLabel"> Alle anzeigen </span>
                  </span>
                </a>
              </li>
              <li class="submenu__item">
                <a [routerLink]="['/fairs', fairId]" class="submenu__link" [attr.data-text]="fair.name">
                  {{ fair.name }}
                </a>
              </li>
              <li class="submenu__item">
                <span class="submenu__separator"></span>
              </li>
              <li class="submenu__item">
                <a
                  [routerLink]="['/fairs', fairId, 'exhibitors']"
                  class="submenu__link"
                  routerLinkActive="submenu__linkActive"
                  data-text="Ausstellerverzeichnis"
                  i18n-data-text="@@uiShell-pastFairExhibitorDirectoryLinkLabel-pseudo"
                  i18n="@@uiShell-pastFairExhibitorDirectoryLinkLabel">
                  Ausstellerverzeichnis
                </a>
              </li>
              @if (fair.hallplan && (hallplanEnabled$ | async)) {
              <li class="submenu__item">
                <a
                  [routerLink]="['/fairs', fairId, 'hall-plan']"
                  class="submenu__link"
                  routerLinkActive="submenu__linkActive"
                  data-text="Hallenplan"
                  i18n-data-text="@@uiShell-pastFairHallplanLinkLabel-pseudo"
                  i18n="@@uiShell-pastFairHallplanLinkLabel">
                  Hallenplan
                </a>
              </li>
              } @if (!fair.discoveryHidden && (searchEnabled$ | async)) {
              <li class="submenu__item">
                <a
                  [routerLink]="['/fairs', fairId, 'search']"
                  class="submenu__link"
                  routerLinkActive="submenu__linkActive"
                  data-text="Entdecken"
                  i18n-data-text="@@uiShell-pastFairSearchLinkLabel-pseudo"
                  i18n="@@uiShell-pastFairSearchLinkLabel">
                  Entdecken
                </a>
              </li>
              } @if ((togglesFacade.flag('kill-program') | async) !== true) { @if (fair.program && programEnabled$ |
              async) {
              <li class="submenu__item">
                <a
                  [routerLink]="['/fairs', fairId, 'program']"
                  class="submenu__link"
                  routerLinkActive="submenu__linkActive"
                  data-text="Rahmenprogramm"
                  i18n-data-text="@@uiShell-pastFairProgramLinkLabel-pseudo"
                  i18n="@@uiShell-pastFairProgramLinkLabel">
                  Rahmenprogramm
                </a>
              </li>
              } }
            </ul>
          </div>
          } } } @else {
          <div class="submenu-wrapper">
            <ul class="submenu">
              <li class="submenu__item">
                @if (['/fairs']; as route) {
                <a
                  [routerLink]="route"
                  [fragment]="'active-fairs'"
                  class="submenu__link"
                  [class.submenu__linkActive]="(isAllFairsRouteActive(route, 'active-fairs') | async) === true"
                  data-text="Aktuelle Veranstaltungen"
                  i18n-data-text="@@uiShell-allFairsSubLinkLabel-pseudo"
                  i18n="@@uiShell-allFairsSubLinkLabel">
                  Aktuelle Veranstaltungen
                </a>
                }
              </li>
              <li class="submenu__item">
                @if (['/fairs']; as route) {
                <a
                  [routerLink]="route"
                  [fragment]="'past-fairs'"
                  class="submenu__link"
                  [class.submenu__linkActive]="(isAllFairsRouteActive(route, 'past-fairs') | async) === true"
                  data-text="Vergangene Veranstaltungen"
                  i18n-data-text="@@uiShell-pastEventsSubLinkLabel-pseudo"
                  i18n="@@uiShell-pastEventsSubLinkLabel">
                  Vergangene Veranstaltungen
                </a>
                }
              </li>
            </ul>
          </div>
          }
        </li>
      </ul>
      } }
    </div>
    <div class="header-desktop-right">
      <ul class="header-desktop-navigation-list">
        <li class="header-desktop-navigation-list-item">
          <a
            class="header-link has-link-icon icon-top"
            [routerLink]="['tickets']"
            routerLinkActive="header-link-active"
            (click)="closeMenu()"
            i18n-data-text="@@uiShell-ticketsLinkLabel-pseudo"
            data-text="Tickets">
            <mat-icon class="header-link-icon icon-tickets material-icons--zoomed">confirmation_number</mat-icon>
            <span i18n="@@uiShell-TicketsLinkLabel">Tickets</span>
          </a>
        </li>
        @if (watchlistEnabled$ | async) {
        <li class="header-desktop-navigation-list-item">
          @if (detailed) {
          <a
            class="header-link has-link-icon icon-top"
            [routerLink]="['watchlist']"
            routerLinkActive="header-link-active"
            (click)="closeMenu()"
            i18n-data-text="@@uiShell-watchlistLinkLabel-pseudo"
            data-text="Merkliste">
            <mat-icon class="header-link-icon icon-watchlist material-icons--zoomed">star</mat-icon>
            <span i18n="@@uiShell-watchlistLinkLabel">Merkliste</span>
          </a>
          }
        </li>
        } @if (isLoggedIn) {
        <li
          class="header-desktop-navigation-list-item header-desktop-navigation-profile-dropdown"
          [matMenuTriggerFor]="menu">
          @if (profileImage?.profile_image_url) {
          <div class="profile-image">
            <img
              src="{{
                profileImage?.profile_image_url
                  | ImageUrl : 'CANTO' : { width: 200, height: 200, fileType: ImageFileTypes.WEBP }
              }}" />
          </div>
          } @else {
          <div class="profile-image-placeholder">{{ this.initials }}</div>
          }
          <div class="profile-dropdown-indicator">
            <mat-icon class="profile-dropdown-indicator__icon">expand_more</mat-icon>
          </div>
        </li>
        } @else {
        <ul class="header-desktop-navigation-sublist">
          <li class="header-desktop-navigation-list-item">
            <a [href]="loginLink" mat-flat-button color="primary" i18n="@@uiShell-signinLinkLabel"> Anmelden </a>
          </li>
        </ul>
        }
      </ul>
    </div>
    <mat-menu #menu="matMenu" class="header-desktop__dropdown" xPosition="before">
      <a
        [routerLink]="['profile']"
        class="header-desktop__dropdown-link header-desktop__dropdown-link--stroked"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{
          matrixParams: 'ignored',
          queryParams: 'ignored',
          paths: 'exact',
          fragment: 'ignored'
        }"
        mat-menu-item>
        <span i18n="@@uiShell-accountLinkLabel">Mein Konto</span>
        <mat-icon class="header-desktop__dropdown-icon">person</mat-icon>
      </a>

      <a
        [routerLink]="['profile', 'business-card']"
        class="header-desktop__dropdown-link header-desktop__dropdown-link--stroked"
        routerLinkActive="active"
        mat-menu-item>
        <span i18n="@@uiShell-businessCardLinkLabel">Meine Visitenkarte</span>
        <mat-icon
          class="header-desktop__dropdown-icon header-desktop__dropdown-icon--business-card"
          svgIcon="business-card"></mat-icon>
      </a>

      <ng-container *planoneFeatureFlagActive="'show-self-service'">
        @if (selfServiceLink) {
        <a
          [href]="selfServiceLink"
          target="_blank"
          class="header-desktop__dropdown-link header-desktop__dropdown-link--stroked"
          routerLinkActive="active"
          mat-menu-item>
          <span i18n="@@uiShell-selfServiceLinkLabel">Self Service</span>
          <mat-icon class="header-desktop__dropdown-icon">tv_options_input_settings</mat-icon>
        </a>
        }
      </ng-container>
      @if (qrCodeScannerEnabled$ | async) {
      <a
        [routerLink]="['scanner']"
        class="header-desktop__dropdown-link header-desktop__dropdown-link--stroked"
        routerLinkActive="active"
        mat-menu-item>
        <span i18n="@@uiShell-scannerLinkLabel">Scanner</span>
        <mat-icon class="header-desktop__dropdown-icon">qr_code_scanner</mat-icon>
      </a>
      }
      <button (click)="doLogout()" class="header-desktop__dropdown-link" mat-menu-item>
        <span i18n="@@uiShell-signoutLinkLabel">Ausloggen</span>
        <mat-icon class="header-desktop__dropdown-icon">logout</mat-icon>
      </button>
    </mat-menu>
  </section>
  <mat-toolbar class="header-mobile">
    <a routerLink="/" (click)="closeMenu()" class="header-mobile-menu-logo">
      <bau365-shell-logo-dark></bau365-shell-logo-dark>
    </a>
    <span class="header-mobile-menu-spacer"></span>
    @if (!isLoggedIn) {
    <ul class="header-mobile-navigation-sublist">
      <li class="header-mobile-navigation-list-item">
        <a [href]="loginLink" mat-flat-button color="primary" i18n="@@uiShell-signinLinkLabel"> Anmelden </a>
      </li>
    </ul>
    }
    <button mat-button class="header-mobile-menu-button" (click)="openOrCloseMenu()">
      <mat-icon>menu</mat-icon>
    </button>
  </mat-toolbar>
</section>
